import {useMemo, useState} from "react";
import {css} from "@panda/css";

import {PercentIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useAmplitudePromotionViewportTracking} from "../../../promotion/hooks/use_amplitude_promotion_viewport_tracking";
import {useOfferPagePromotionTrackingIds} from "../../../promotion/hooks/use_offer_page_promotion_tracking_ids";
import {getAmplitudeOfferPagePromotionTrackingContext} from "../../../promotion/tracking/get_amplitude_offer_page_promotion_tracking_context";
import {trackAmplitudeOfferSelectPromotion} from "../../../promotion/tracking/track_amplitude_offer_promotion_events";
import {useApplicationFormPromotionInfo} from "../../hooks/use_application_form_promotion_info";

const LONG_DESCRIPTION_CHARS = 160;

export const ApplicationFormPromotionInfo = () => {
    const [expanded, setExpanded] = useState(false);

    const promotion = useApplicationFormPromotionInfo();
    const trackingIds = useOfferPagePromotionTrackingIds();

    const trackingContext = useMemo(() => {
        if (!promotion || !trackingIds) {
            return null;
        }

        return getAmplitudeOfferPagePromotionTrackingContext({
            promotion,
            offerId: trackingIds.offerId,
            propertyId: trackingIds.propertyId,
            creativeSlot: "cta_box"
        });
    }, [promotion, trackingIds]);

    const {elementId} = useAmplitudePromotionViewportTracking({
        trackingContext,
        elementId: "amplitude-cta-box-promotion"
    });

    const description = promotion?.description?.trim() || null;
    const isLongDescription = Boolean(description && description.length > LONG_DESCRIPTION_CHARS);

    const visibleDescription = useMemo(() => {
        if (!description) {
            return null;
        }

        if (!isLongDescription || expanded) {
            return description;
        }

        return `${description.slice(0, LONG_DESCRIPTION_CHARS).trim()}…`;
    }, [description, isLongDescription, expanded]);

    const handleShowMoreClick = () => {
        if (trackingContext) {
            trackAmplitudeOfferSelectPromotion(trackingContext);
        }

        setExpanded(true);
    };

    if (!promotion) {
        return null;
    }

    return (
        <div className={promotionInfo} data-id={elementId}>
            <div className={promotionIcon}>
                <PercentIcon size="2" wrapperSize="2" />
            </div>

            <div className={textColumnStyle}>
                <Text variant="info_txt_1">
                    <strong>Oferta promocyjna:</strong> {promotion.name}
                    {visibleDescription ? ` ${visibleDescription}` : null}
                </Text>

                {isLongDescription && !expanded && (
                    <button type="button" onClick={handleShowMoreClick}>
                        Pokaż więcej
                    </button>
                )}
            </div>
        </div>
    );
};

const promotionInfo = css({
    display: "grid",
    gridTemplateColumns: "20px 1fr",
    gridTemplateRows: "auto auto",
    p: 2,
    mb: 3,
    columnGap: 0.5,
    backgroundColor: "color-mix(in srgb, var(--colors-highlight) 30%, transparent)",
    borderRadius: "var(--radii-2)"
});

const promotionIcon = css({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const textColumnStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 0.5
});
import {useMemo, useState} from "react";
import {css} from "@panda/css";

import {PercentIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useAmplitudePromotionViewportTracking} from "../../../promotion/hooks/use_amplitude_promotion_viewport_tracking";
import {useOfferPagePromotionTrackingIds} from "../../../promotion/hooks/use_offer_page_promotion_tracking_ids";
import {getAmplitudeOfferPagePromotionTrackingContext} from "../../../promotion/tracking/get_amplitude_offer_page_promotion_tracking_context";
import {trackAmplitudeOfferSelectPromotion} from "../../../promotion/tracking/track_amplitude_offer_promotion_events";
import {useApplicationFormPromotionInfo} from "../../hooks/use_application_form_promotion_info";

const LONG_DESCRIPTION_CHARS = 160;

export const ApplicationFormPromotionInfo = () => {
    const [expanded, setExpanded] = useState(false);

    const promotion = useApplicationFormPromotionInfo();
    const trackingIds = useOfferPagePromotionTrackingIds();

    const trackingContext = useMemo(() => {
        if (!promotion || !trackingIds) {
            return null;
        }

        return getAmplitudeOfferPagePromotionTrackingContext({
            promotion,
            offerId: trackingIds.offerId,
            propertyId: trackingIds.propertyId,
            creativeSlot: "cta_box"
        });
    }, [promotion, trackingIds]);

    const {elementId} = useAmplitudePromotionViewportTracking({
        trackingContext,
        elementId: "amplitude-cta-box-promotion"
    });

    const description = promotion?.description?.trim() || null;
    const isLongDescription = Boolean(description && description.length > LONG_DESCRIPTION_CHARS);

    const visibleDescription = useMemo(() => {
        if (!description) {
            return null;
        }

        if (!isLongDescription || expanded) {
            return description;
        }

        return `${description.slice(0, LONG_DESCRIPTION_CHARS).trim()}…`;
    }, [description, isLongDescription, expanded]);

    const handleShowMoreClick = () => {
        if (trackingContext) {
            trackAmplitudeOfferSelectPromotion(trackingContext);
        }

        setExpanded(true);
    };

    if (!promotion) {
        return null;
    }

    return (
        <div className={promotionInfo} data-id={elementId}>
            <div className={promotionIcon}>
                <PercentIcon size="2" wrapperSize="2" />
            </div>

            <div className={textColumnStyle}>
                <Text variant="info_txt_1">
                    <strong>Oferta promocyjna:</strong> {promotion.name}
                    {visibleDescription ? ` ${visibleDescription}` : null}
                </Text>

                {isLongDescription && !expanded && (
                    <button type="button" onClick={handleShowMoreClick}>
                        Pokaż więcej
                    </button>
                )}
            </div>
        </div>
    );
};

const promotionInfo = css({
    display: "grid",
    gridTemplateColumns: "20px 1fr",
    gridTemplateRows: "auto auto",
    p: 2,
    mb: 3,
    columnGap: 0.5,
    backgroundColor: "color-mix(in srgb, var(--colors-highlight) 30%, transparent)",
    borderRadius: "var(--radii-2)"
});

const promotionIcon = css({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const textColumnStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 0.5
});
